import { wsClient, WsRecvType, IWsHandler } from '../client'
import { toast } from 'react-toastify'

type IErrorHandler = IWsHandler<undefined>

export default function () {
    wsClient.submitHandler(WsRecvType.Error, (({ message }) => {
        console.log(`%c[WsClient] Error`, 'color: red', message)
        toast.error(message)
    }) as IErrorHandler)
}
